import { createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("COUNTRIES"),
};
